<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>RX Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row" style="display: flex; flex-wrap: wrap;">
            <div v-if="chosenDesign" class="columns small-12 medium-3 text-left lp">
                <p class="small-text">{{choices.lensDesignLabel}}: <br>
                    <strong>{{chosenDesign}}</strong>
                </p>
            </div>
            <div v-if="chosenMaterial" class="columns small-12 medium-3 text-left lp">
                <p class="small-text">{{choices.lensMaterialLabel}}: <br>
                    <strong>{{chosenMaterial}}</strong>
                </p>
            </div>
            <div v-if="chosenPhotochromic" class="columns small-12 medium-3 text-left lp end">
                <p class="small-text">{{choices.lensPhotochromicLabel}}: <br>
                    <strong>{{chosenPhotochromic}}</strong>
                </p>
            </div>
            <div v-if="chosenTreatment" class="columns small-12 medium-3 text-left lp">
                <p class="small-text">{{choices.lensTreatmentLabel}}: <br>
                    <strong>{{chosenTreatment}}</strong>
                </p>
            </div>
        </div>
        <div class="row">
            <div v-if="sampleobject.PantoAngle" class="columns small-12 medium-2 text-left lp">
                <!--<p class="small-text"> Design: <br>-->
                <p class="small-text"> Panto Angle: <br>
                    <strong>{{sampleobject.PantoAngle}}</strong>
                </p>
            </div>
             <div v-if="sampleobject.WrapAngle" class="columns small-12  medium-2  text-left lp">
                <!--<p class="small-text"> Material: <br>-->
                <p class="small-text"> Wrap Angle: <br>
                    <strong>{{sampleobject.WrapAngle}}</strong>
                </p>
            </div>
            <div v-if="sampleobject.LeftVertexDistance" class="columns small-12  medium-3  text-left lp end">
                <!--<p class="small-text"> Photochromic: <br>-->
                <p class="small-text"> Left Vertex Distance: <br>
                    <strong>{{sampleobject.LeftVertexDistance}}</strong>
                </p>
            </div>
            <div v-if="sampleobject.RightVertexDistance" class="columns small-12  medium-3  text-left lp">
                <!--<p class="small-text"> Treatment: <br>-->
                <p class="small-text">Right Vertex Distance: <br>
                    <strong>{{sampleobject.RightVertexDistance}}</strong>
                </p>
            </div>
        </div>
        <div class="row">
            <div v-if="sampleobject.NVB" class="columns small-12 medium-4 text-left lp">
                <!--<p class="small-text"> Design: <br>-->
                <p class="small-text"> NVB: <br>
                    <strong>{{sampleobject.NVB}}</strong>
                </p>
            </div>
             <div v-if="sampleobject.Initials" class="columns small-12  medium-4  text-left lp">
                <!--<p class="small-text"> Material: <br>-->
                <p class="small-text"> Initials: <br>
                    <strong>{{sampleobject.Initials}}</strong>
                </p>
            </div>
            <div v-if="sampleobject.SPBaseCurve" class="columns small-12  medium-4  text-left lp end">
                <!--<p class="small-text"> Photochromic: <br>-->
                <p class="small-text"> Base Curve: <br>
                    <strong>{{sampleobject.SPBaseCurve}}</strong>
                </p>
            </div>
        </div>
        <div class="row small-collapse">
            <div class="small-12 medium-4 columns">
                <table class="rx-table-for-print">
                    <thead>
                        <tr>
                            <th class="TableInputBox leading-col"></th>
                            <th>Sph.</th>
                            <th>Cyl.</th>
                            <th>Axi.</th>
                            <th>Add.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="TableInputBox leading-col">R</td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.resph}} </div>
                            </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.recyl}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.reaxis}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.readd}}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="TableInputBox leading-col">L</td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.lesph}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.lecyl}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.leaxis}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.leadd}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="small-12 medium-5 columns">
                <table class="rx-table-for-print">
                    <thead>
                        <tr>
                            <th class="show-for-small-only leading-col"></th>
                            <th>H. Prism</th>
                            <th>H. Base</th>
                            <th>V. Prism</th>
                            <th>V. Base</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="show-for-small-only leading-col"> R </td>
                            <td class="TableInputBox">
                                <div>{{sampleobject.rehorizPrismValue}} &nbsp; </div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{directionTextAllButLEHoriz(sampleobject.rehorizPrismDirection)}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.reverticalPrismValue}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{directionTextAllButLEHoriz(sampleobject.reverticalPrismDirection)}}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="show-for-small-only leading-col">L</td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.lehorizPrismValue}} &nbsp;</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{directionTextLEHoriz(sampleobject.lehorizPrismDirection)}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.leverticalPrismValue}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{directionTextAllButLEHoriz(sampleobject.leverticalPrismDirection)}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="small-12 medium-3 columns end">
                <table class="rx-table-for-print">
                    <thead>
                        <tr>
                            <th class="show-for-small-only"></th>
                            <th>Dist PD</th>
                            <th>Eye Height</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="show-for-small-only  leading-col">R</td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.redistPD}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.resegHeight}}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="show-for-small-only leading-col">L</td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.ledistPD}}</div>
                            </td>
                            <td class="TableInputBox">
                                <div> {{sampleobject.lesegHeight}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
function getChoice(choices, choice, sampleobject = null) {
  if (choices.length == 1) {
    return choices[0].label;
  }
  for (let d of choices) {
    if (d.value === choice) {
      return d.label;
    }
  }
  if (choices.length == 0) {
    sampleobject.photochromic = "";
  }
  return "";
}

export default {
  props: ["sampleobject", "choices"],
  methods: {
    directionTextAllButLEHoriz(val) {
      switch (val) {
        case "000":
          return "IN";
          break;
        case "180":
          return "OUT";
          break;
        case "090":
          return "UP";
          break;
        case "270":
          return "DOWN";
          break;
        default:
          return "";
      }
    },
    directionTextLEHoriz(val) {
      switch (val) {
        case "180":
          return "IN";
          break;
        case "000":
          return "OUT";
          break;
      }
    }
  },
  computed: {
    chosenDesign() {
      return getChoice(this.choices.design, this.sampleobject.design);
    },
    chosenMaterial() {
      return getChoice(this.choices.material, this.sampleobject.material);
    },
    chosenTreatment() {
      return getChoice(this.choices.treatment, this.sampleobject.treatment);
    },
    chosenPhotochromic() {
      return getChoice(
        this.choices.photochromic,
        this.sampleobject.photochromic,
        this.sampleobject
      );
    }
  }
};
</script>
<style>
th {
  background-color: ghostwhite;
}

@media print {
  th {
    background-color: ghostwhite !important;
    -webkit-print-color-adjust: exact;
  }
}

.rx-info-padding-bottom {
  padding-bottom: 10px;
}

.rx-table-for-print {
  border: 1px solid darkgray;
  width: 100%;
  border-collapse: collapse;
  font-size: 8pt;
  font-style: normal;
}

.rx-table-for-print th,
.rx-table-for-print td {
  border: 1px solid darkgray;
  border-collapse: collapse;
}

.rx-table-for-print td div {
  font-size: 9pt;
  font-weight: bold;
}
</style>
